import { createContext, useContext } from 'react';

export const AutoScrollContext = createContext<boolean>(false);

export const useAutoScrollContext = () => useContext(AutoScrollContext);
